<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  import type { AnimationItem, LottiePlayer } from 'lottie-web';

  import animationData from '../data/viewer-icon.json';
  import { initLottieLifecycle } from '../libs';
  import { viewerIconDOTriggers } from '../models';
  import { triggeredUIDs } from '../models/triggered-UIDs';
  import type { LottieUID } from '../types';

  const dispatch = createEventDispatcher<{ 'lottie-loaded': void }>();

  export let width: number;

  export let uid: LottieUID;

  initLottieLifecycle(uid);

  $: ({ loop, oneTime, reverse } = $viewerIconDOTriggers); // <- Triggers

  $: loop && lot && triggeredUIDs.exist(uid, 'loop') && loopAnimation();
  $: oneTime && lot && triggeredUIDs.exist(uid, 'oneTime') && oneTimeAnimation();
  $: reverse && lot && triggeredUIDs.exist(uid, 'reverse') && oneTimeRevertAnimation();

  let lot: AnimationItem;
  let container: HTMLDivElement;

  function loopAnimation() {
    lot.setLoop(true);
    if (lot.isPaused) lot.goToAndPlay(1);
  }

  function oneTimeAnimation() {
    lot.setLoop(false);
    lot.playSegments([1, 30], true);
  }

  function oneTimeRevertAnimation() {
    lot.setLoop(false);
    lot.playSegments([30, 1], true);
  }

  function updateChildrenStyles() {
    const paths = container.querySelectorAll('path[fill="rgb(0,0,0)"]');

    for (const path of paths) {
      path.setAttribute('fill', 'currentColor');
    }
  }

  onMount(async () => {
    const lottie = (await import('lottie-web')) as unknown as LottiePlayer;
    lot = lottie.loadAnimation({
      container,
      animationData,
      loop: true,
      autoplay: false,
      initialSegment: [1, 30],
    });

    updateChildrenStyles();
    dispatch('lottie-loaded');
  });
</script>

<div bind:this="{container}" style="width: {width}px; height: {width}px"></div>
